import * as Yup from 'yup';

import {
  CreateMidtermTransactionField,
  getGenericFieldRequiredErrorMessage,
  getMidtermTransactionWrongTypeErrorMessage,
} from '@converge/data';

export const stringRequired = (fieldName: CreateMidtermTransactionField) => {
  return Yup.string()
    .typeError(getMidtermTransactionWrongTypeErrorMessage(fieldName))
    .required(getGenericFieldRequiredErrorMessage())
    .trim()
    .min(1, getMidtermTransactionWrongTypeErrorMessage(fieldName));
};

export const CreateMidtermTransactionFieldsSchema = Yup.object({
  [CreateMidtermTransactionField.startDate]: Yup.string(),
});
